<div matTooltip="{{tooltip}}" [ngSwitch]="status">

  <!-- Alive -->
  <div *ngSwitchCase="1">
    <i class="material-icons">edit</i>
  </div>

  <!-- Sale locked -->
  <div *ngSwitchCase="2">
    <i class="material-icons">edit</i>
  </div>

  <!-- End of Right -->
  <div *ngSwitchCase="3">
    <i class="material-icons">edit</i>
  </div>

  <!-- While stocks last -->
  <div *ngSwitchCase="4">
    <i class="material-icons">edit</i>
  </div>

  <!-- Removed form sale -->
  <div *ngSwitchCase="5">
    <i class="material-icons">edit</i>
  </div>

  <!-- Saved -->
  <div *ngSwitchCase="6">
    <i class="material-icons blue">save</i>
  </div>

  <!-- Validation in Progress -->
  <div *ngSwitchCase="7">
    <i class="material-icons blue">alarm_on</i>
  </div>

  <!-- NOA pending -->
  <div *ngSwitchCase="8">
    <i class="material-icons blue">shopping_basket</i>
  </div>

  <!-- Refused -->
  <div *ngSwitchCase="9">
    <!--<mat-icon class="mati-close-circle red size"></mat-icon>-->
    <i class="material-icons red">highlight_off</i>
  </div>

  <!-- Validated -->
  <div *ngSwitchCase="10">
    <i class="material-icons green">alarm_on</i>
  </div>

  <!-- NOA refused -->
  <div *ngSwitchCase="11">
    <i class="material-icons red">shopping_basket</i>
  </div>

  <!-- NOA error -->
  <div *ngSwitchCase="12">
    <i class="material-icons red">shopping_basket</i>
  </div>

  <!-- Refused -->
  <div *ngSwitchCase="13">
    <!--<mat-icon class="mati mati-close-circle red size"></mat-icon>-->
    <i class="material-icons red">highlight_off</i>
  </div>

  <!-- Accepted -->
  <div *ngSwitchCase="14">
    <i class="material-icons green">alarm_on</i>
  </div>

  <!-- Problem -->
  <div *ngSwitchCase="15">
    <!--<mat-icon class="mati mati-close-circle red size"></mat-icon>-->
    <i class="material-icons red">highlight_off</i>
  </div>

  <!-- Sale locked -->
  <div *ngSwitchCase="16">
    <i class="material-icons">edit</i>
  </div>

  <!-- Sale locked -->
  <div *ngSwitchCase="17">
    <i class="material-icons">edit</i>
  </div>

  <!-- Sale locked -->
  <div *ngSwitchCase="18">
    <i class="material-icons">edit</i>
  </div>

  <!-- sent NOA -->
  <div *ngSwitchCase="19">
    <i class="material-icons blue">shopping_basket</i>
  </div>

  <!-- Delivered -->
  <div *ngSwitchCase="20">
    <mat-icon class="mdi mdi-truck-delivery purple size"></mat-icon>
  </div>

  <!-- Deleted -->
  <div *ngSwitchCase="21">
    <i class="material-icons red">delete_forever</i>
  </div>

  <!-- Error SAP -->
  <div *ngSwitchCase="22">
    <i class="material-icons red">shopping_basket</i>
  </div>

  <!-- Partially Delivered -->
  <div *ngSwitchCase="23">
    <!--<mat-icon class="mati mati-truck-delivery success size"></mat-icon>-->
    <i class="material-icons success">local_shipping</i>
  </div>

  <!-- Validation CDG -->
    <div *ngSwitchCase="24">
      <i class="material-icons purple">alarm_on</i>
    </div>

</div>
